import * as React from 'react';
import { useEffect, useRef, useState, useContext } from "react";
import { SignupContext, SignupProvider }  from "../context/SignupProvider";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Rating from '@mui/material/Rating';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Copyright from './Copyright';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SignupOrderOption from './SignupOrderOption';
import ConfirmSignupModal from './ConfirmSignupModal';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';

import ExploreIcon from '@mui/icons-material/Explore';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShareIcon from '@mui/icons-material/Share';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import StarIcon from '@mui/icons-material/Star';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import * as API from '../utils/APICalls'
import InquirySendModal from './InquirySendModal';
import { AppBar, CardMedia, List, ListItem, ListItemIcon, ListItemText, Modal, Tooltip } from '@mui/material';

import * as vars from '../utils/vars'
import * as SMBVars from '../utils/SMBVars'
import OperatingLogoCopy from './OperatingLogoCopy';
import CloseButton from './CloseButton';
import MapComponent from './MapComponent';
import MapContainer from './MapContainer';
import ModalComponent from './Modal';


// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function StephonsMobileBistro() {
    

 const { signupData, 
        setSignupData,
        updateSignupData, 
        tempOrder,
        setTempOrder,
        updateTempOrder,
        firstName, 
        setFirstName,
        lastName, 
        setLastName,
        email, 
        setEmail,
        phone, 
        setPhone,
        department, 
        setDepartment,
        notes, setNotes, 
        inquiryText, 
        setInquiryText,
        isFollower, 
        setIsFollower} = useContext(SignupContext);
 const [ orderObj, setOrderObj ] = useState({})
//  const [ firstName, setFirstName ] = useState('')
//  const [ lastName, setLastName ] = useState('')
//  const [ email, setEmail ] = useState('')
//  const [ phone, setPhone ] = useState('')
//  const [ department, setDepartment ] = useState('')
//  const [ inquiryText, setInquiryText ] = useState('')
//  const [ isFollower, setIsFollower ] = useState(true)
    const [ inquiry, setInquiry ] = useState({})
    const [ orderView,setOrderView ] = useState(true)
    const [ showAbout, setShowAbout ] = useState(true)
    const [ showMap, setShowMap ] = useState(false)
    const [ open, setOpen ] = useState(false);
    const [ isSubmitting , setIsSubmitting ] = useState(false)
    const [ vCardData, setVCardData ] = useState()
    const [ actionError, setActionError ] = useState('')
    const [ modalView, setModalView ] = useState('menu')


  const [snackOpen, setSnackOpen] = React.useState(false);
  /*/----------------------------//
    Campaign Details
//----------------------------*/

const owner = '65d3ad8490ca4ec165d36e83'
const owner_email ='stephon5241960@gmail.com'
const owner_firstName ='Stephon'
const owner_lastName ='VanDyke'
const owner_phone = '(775) 219-9954'
const cover_pic = 'https://res.cloudinary.com/dzxzdsnha/image/upload/v1708358719/StephonsMobileBistro-Reno-Promo-image-01_m1zeaq.jpg'
const cover_pic2 = 'https://res.cloudinary.com/dzxzdsnha/image/upload/v1708370141/StephonsMobileBistro-Reno-Promo-image-01-Crop.jpg'
const owner_pic = 'https://res.cloudinary.com/dzxzdsnha/image/upload/v1708359022/StephonsMobileBistro-Avatar_xiuawi.jpg'
const operating_name  = `Stephon's Mobile Bistro`
const services = ['Personal Chef','Catering Parties', 'Special Events','Corporate Events','Church Events']
const tagLine =  "IT'S ALL GOOD!"
const tagLine_html = `<b style='font-family:Gilroy,sans-serif;'>IT'S <i>ALL</i> GOOD!</b>`
const description = 'Home Style Cooking'

const ownerObj ={

    firstName : {on:true, data:owner_firstName},
    lastName : {on:true, data:owner_lastName},
    organization: {on:true, data:operating_name},
    email: {on:true, data:owner_email},
    phone: {on:true, data:owner_phone},
    alt_pic: {on:true, data:owner_pic},
    directLink:{on:true, data:['https//qaura.pro/partners/stephons-mobile-bistro']}
}
const campaingName  = 'Signup Sheet'
const type= 'bake sale'

const infoHTML = ` <h2 style='font-family:"Gilroy",sans-serif;text-align:center;'>Helloooo There! </h2><br/> <b style='font-family:"Protest Riot";text-align:center;font-size:1.25rem'>&nbsp; &nbsp;I'm Stephon</b>, and welcome to my bistro!  From our homemade sweet potato chips to our steak sandwiches, we have something for everyone!<br/> <br/>&nbsp; &nbsp; Have a look at my menu and be sure to check back for locations and updates on my one of a kind home style cooking! </b><br/> <br/> <b style='font-family:"Protest Riot";'>Thanks for stopping by!</b>`


const items = vars.items



   const fetchVCard  = async(ownerInfo) =>{
        // console.log('fetchvCard persona: ', persona)
        if(ownerInfo){
            const data = await API.fetchVCard(ownerInfo)
            console.log('fetchvCard data: ', data)
            setVCardData(data)
            // setVCardData(data?{...data}:fetchVCard())
            console.log('fetchvCard VCardData: ', vCardData)
        }
    }

  const handleSnackClick = () => {
    setSnackOpen(true);
  };
  
  const handleSnackClose = (event, reason) => {
      if (reason === 'clickaway') {
          return;
        }
        
        setSnackOpen(false);
    };
    
    const handleMapOpen = () => {
      setShowMap(true);
      setModalView('map')
    };
    const handleMapClose = () => {
        setShowMap(false);
        setModalView('')
    };
    const handleMenuOpen = () => {
        setShowMap(true);
        setModalView('menu')
    };
    const handleMenuClose = () => {
        setShowMap(false);
        setModalView('')
    };


const orderTemplate = () =>{
    return items?.map((e,i)=>{
        return ({
        item_type: e?.type,
        size: e?.sizes[0],
        quantity:0

    }) })
}

const getAvg = (values) => {
    return values?.reduce((m, x, i) => m + (x - m) / (i + 1), 0)
}
const saveVCard = (data) =>{
    // vCard.saveToFile(`./${persona?.preferredName?.data?persona?.preferredName?.data:persona?.firstName?.data}.vcf`)
    console.log('[save vCard]: ',data)
    downloadToFile(data, `${ownerObj?.firstName?.data}-${ownerObj?.lastName?.data}-vCard.vcf`, 'text/vcard')
}

const downloadToFile = (content, filename, contentType) => {
  const a = document.createElement('a');
  const file = new Blob([content], { type: contentType });

  a.href = URL.createObjectURL(file);
  a.download = filename;
  a.click();

  URL.revokeObjectURL(a.href);
}
//TODO MAKE FUNCTION TO GET CAMPAIGN DETAILS FROM DB TO BUILD ITEM LIST

const handleAboutHide =(e)=>{
    setShowAbout(!showAbout)
}
    const handleInquirySubmit =  (e) =>{
        e.preventDefault(e);
        setIsSubmitting(true)

        // console.log('inquiry:', inquiryText)
        // const data = new FormData(e.currentTarget);
            setInquiry({...inquiry,
                owner_email,
                owner,
                operating_name,
                campaingName,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone:  phone,
                department: department,
                // firstName: data.get('firstName'),
                // lastName: data.get('lastName'),
                // email: data.get('email'),
                // phone: data.get('phone'),
                // department: data.get('department'),
                isFollower: isFollower,
                inquiry: inquiryText,
                isInquiry: true,
                // tempOrder: tempOrder
            })
        try{
            
            if(inquiry.firstName && inquiry.lastName && inquiry?.email && inquiry?.inquiry){
                const inq_res = API.saveSignup(inquiry)
                if( inq_res ){
                    window.location.assign(`/thanks/${owner_email}`)
                 //    console.log("inq_res", inq_res )
                }
            }
            setIsSubmitting(false)

        }catch(err){
            setIsSubmitting(false)

            console.log(err)
        } 
   
    }
    const handleInquiryChange = (e) =>{
       setInquiryText(e.target.value)
        // console.log('inquiry:', inquiry)

    }
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true)
    // const data = new FormData(event.currentTarget);
    // setOrderObj({
    //     ...orderObj,
    //     owner_email,
    //     owner,
    //     operating_name,
    //     campaingName,
    //     firstName: firstName,
    //     lastName: lastName,
    //     email: email,
    //     phone:  phone,
    //     department: department,
    //     // firstName: data.get('firstName'),
    //     // lastName: data.get('lastName'),
    //     // email: data.get('email'),
    //     // phone: data.get('phone'),
    //     // department: data.get('department'),
    //     isFollower: isFollower,
    //     inquiry: inquiryText
    //     // tempOrder: tempOrder
       
    // })
    if( firstName === ''|| lastName === '' ||
        email  === '' || phone  === ''){
            alert('Please complete or re-enter your contact information')
        setIsSubmitting(false)
        }
    else{

        try{
    
            updateSignupData({ ...signupData,
                owner_email,
                owner,
                operating_name,
                campaingName,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone:  phone,
                department: department,
                isFollower: isFollower,
                inquiry: inquiryText,
                order:[...tempOrder],
                tempOrder
            })
            console.log('Submit tempOrder',  tempOrder);
            console.log('signupData', signupData);
            setOpen(!open)
            setIsSubmitting(false)
        }catch(err){
            setIsSubmitting(false)
            setActionError('Order failed to submit')
            console.log(err)  
        }
    }
  };
  
    useEffect(() => {
        window.scrollTo(0, 0)
        if(!vCardData){
            fetchVCard(ownerObj)
        }
    }, [vCardData])

    useEffect(() => {
        
    }, [signupData,orderObj,tempOrder])

  return (
    <SignupProvider>
        <Container  sx={{position: 'relative', boxShadow:'inset 0px 0px 15px 10px rgba(0,0,0,0.8)',
                 width:'100%',height:'fit-content',p:0, backgroundImage:`url("/assets/BodyBG2.png")`,
                 backgroundAttachment:'fixed',maxWidth:'90vw'}}>

        <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="md" minWidth="xs" className='signup-container' >
            <Modal
                open={showMap}
                onClose={handleMapClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    minHeight:'60vh',
                    maxWidth:'98vw',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,}}>
                        <CloseIcon onClick={handleMapClose}  color='#000'sx={{position:'absolute',right:'0.5rem',top:'0.5rem'}}/>
             
                   <Stack direction="row" spacing={1} alignItems="center" justifyContent='center'>
                <Typography>Map</Typography>
                <Switch defaultChecked inputProps={{ 'aria-label': 'ant design' }} onChange={(e)=>{
                    if(modalView ==='map'){
                        setModalView('menu')
                    }
                    if(modalView ==='menu'){
                        setModalView('map')
                    }
                }} checked={modalView ==='menu'} />
                
                <Typography>Menu</Typography>
            </Stack>

               <Typography id="modal-modal-title" variant="h6" component="h2" style={{fontFamily:'Protest Riot',textAlign:'center'}}>
                    Come stop by!
                </Typography>
            
              {modalView ==='map' &&(  
                    <Box>
                        {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Map description (coming soon!)
                        </Typography> */}
                        {/* <Box sx={{border:'1px solid #000'}}> */}
                        <Box sx={{border:'1px solid #000',overflow:'hidden',minHeight:'40vh'}}>

                        <MapContainer />
                    
                        </Box>  
                        {/* </Box> */}
                    </Box>
                     )}
              {modalView ==='menu' &&(  
                    <Container sx={{padding:'0.5rem', maxHeight:'80vh'}}>
                        {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                           Menu Items 
                        </Typography> */}
                        <h2  sx={{ mt: 2 ,margin:'auto',alignS:'center'}}>
                           Menu
                        </h2>
                        <Box sx={{border:'1px solid #000',minHeight:'60vh',
                            gap:'0.75rem',padding:'0.75rem',borderRadius:'7px',
                            display:'flex',flexDirection:'column', maxHeight:'70vh', overflowY:'scroll'}}>
                            
                        <h3 sx={{ mt: 2 ,margin:'auto',alignS:'center'}}>
                            <u>Burgers</u>
                        </h3>
                        {SMBVars?.menu?.map((item,i)=>{
                            if(item?.tags?.includes('burger')){

                                return <Box>
                                    <Typography sx={{fontWeight:'bold'}}><span style={{fontFamily:'Protest Riot,sans-serif'}}>{item?.name}</span> - ${item?.prices[0]} </Typography>
                                    <Typography sx={{fontSize:'1rem'}}>{item?.descr}</Typography>
                                </Box>
                            }

                            })
                        }

                        <h3 sx={{ mt: 2 ,margin:'auto',alignS:'center'}}>
                            <u>Sandwiches</u>
                        </h3>
                        {SMBVars?.menu?.map((item,i)=>{
                            if(item?.tags?.includes('sandwich')){

                                return <Box>
                                    <Typography sx={{fontWeight:'bold'}}><span style={{fontFamily:'Protest Riot,sans-serif'}}>{item?.name}</span> - ${item?.prices[0]} </Typography>
                                    <Typography sx={{fontSize:'1rem'}}>{item?.descr}</Typography>
                                </Box>
                            }

                            })
                        }
                        <h3 sx={{ mt: 2 ,margin:'auto',alignS:'center'}}>
                            <u>Sides</u>
                        </h3>
                        {SMBVars?.menu?.map((item,i)=>{
                            if(item?.tags?.includes('side')){

                                return <Box>
                                    <Typography sx={{fontWeight:'bold'}}><span style={{fontFamily:'Protest Riot,sans-serif'}}>{item?.name}</span> - ${item?.prices[0]} </Typography>
                                    <Typography sx={{fontSize:'1rem'}}>{item?.descr}</Typography>
                                </Box>
                            }

                            })
                        }
                        &nbsp;
                        </Box>
                    </Container>
                     )}
                </Box>
            </Modal>
              <AppBar position="sticky"
                sx={{background:"rgba(255,255,255,1)",boxShadow:'0px 1px 5px 3px  rgba(0,0,0,0.5)', 
                top: '0px', left:'0px', maxWidth:'100vw', width:'100%',
                backdropFilter:'blur(6px)', display:'flex',position:"sticky",
                border:'3px solid #000', borderTop:0,
                flexDirection:' row', justifyContent:'center',borderRadius:'0px 0px 5px 5px',
                background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 15%, rgba(255,255,255,1) 100%)',
                }}>

                <Tooltip title="See where I'm serving!">
                    <Box sx={{cursor:'pointer'}} href="#" target='_blank' onClick={handleMapOpen}>
                        <ExploreIcon sx={{zIndex:2, color:'#000', width:'3.5rem'}}  />     
                    </Box>
                </Tooltip>

                <Tooltip title="Follow on Instagram">
                    <Link href="#" target='_blank'>
                        <InstagramIcon sx={{zIndex:2, color:'#000', width:'3.5rem'}}  />     
                    </Link>
                </Tooltip>

                    <Tooltip title="Follow on Facebook">
                        <Link href="https://www.facebook.com/profile.php?id=100064519126966" target='_blank'>
                            <FacebookIcon sx={{zIndex:2, color:'#000', width:'3.5rem'}} />
                        </Link>
                    </Tooltip>
                    <Tooltip title="Copy to clipboard">

                        <Link href="#"  onClick={(e)=>{
                            // let val=ownerObj?.directLink?.data.toString()
                            let val='https://qaura.pro/partners/stephons-mobile-bistro'
                            console.log('url:',val)
                            
                            // navigator.clipboard.writeText(val);
                            // alert(val,'\nurl copied to clipboard')
                            navigator.clipboard
                                .writeText(val)
                                .then(() => {
                                    alert(`${val} successfully copied`);
                                })
                                .catch(() => {
                                    alert("something went wrong");
                                });
                            handleSnackClick()
                            }} >

                        <ShareIcon sx={{zIndex:2, color:'#000', width:'3.5rem'}} />
                        {/* <Snackbar
                            anchorOrigin={'bottom'} 
                            open={snackOpen}
                            onClose={handleSnackClose}
                            message="url copied to clipboard!"
                        
                        /> */}
                        </Link>
                    </Tooltip>
                    <Tooltip title="Download contact vCard">

                <Link href="#" label='save contact to phone' onClick={()=>{
                    console.log('click',vCardData)
                    // if(vCardData){
                        saveVCard(vCardData)
                        // }
                    }}>
                     <ContactPhoneIcon sx={{zIndex:2, color:'#000', width:'3.5rem'}} />
                </Link>
                    </Tooltip>
            </AppBar>
            <CssBaseline />
            <Box 
            // component='img'
                sx={{position:'absolute', top:'0px', left:'0px', 
                // backgroundColor:'rgba(203, 244, 245, 0.8)', 
                background: 'rgb(255,255,255)',
                background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 15%, rgba(0,0,0,1) 100%)',
                width:'100%',height:'225px',zIndex:0, overflow:'hidden',
                boxShadow:'inset 0px -3px 10px 5px rgba(255,255,255,0.8),0px 10px 15px 10px rgba(0,0,0,0.4)', 
                opacity:1,borderBottom:'3px solid #000',
                marginBottom:'1.5rem'
            }}
            // src ='https://res.cloudinary.com/dzxzdsnha/image/upload/v1705938116/Orzo_fkhl2x.jpg'
                >
          

            <Box 
            // component='img'
                sx={{position: 'absolute', top:'0px', left:'0px', 
                backgroundColor:'rgba(203, 244, 245, 0.8)',maxWidth:'100vw',
                 width:'100%',height:'auto',minHeight:'240px',zIndex:'-1', opacity:'1',
                boxShadow:'inset 0px -3px 10px 5px rgba(255,255,255,0.8),',//,0px -2px 5px 3px rgba(0,0,0,0.5)'
                backgroundImage:`url("${cover_pic}")`,//backgroundAttachment:'fixed',
                backgroundRepeat: 'no-repeat',backgroundSize: 'cover',
                
                }}
                // src = {cover_pic}
                // src ='https://res.cloudinary.com/dzxzdsnha/image/upload/v1705938116/Orzo_fkhl2x.jpg'
                >
            </Box>
            </Box>

            <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent:'center',
                gap: '0.5rem',
            }}
            >
                 <Box 
            //  component='img'
            // src='/assets/BodyBG_.png'
            sx={{ position:'absolute', top:0, left:0, zIndex:-1, height:'100%',maxWidth:'100vw', width:'100%',backgroundColor:'rgba(0,0,0,0.3)',
            background:`linear-gradient(   45deg,
                hsl(240deg 100% 20%) 0%,
                hsl(289deg 100% 21%) 11%,
                hsl(315deg 100% 27%) 22%,
                hsl(329deg 100% 36%) 33%,
                hsl(337deg 100% 43%) 44%,
                hsl(357deg 91% 59%) 56%,
                hsl(17deg 100% 59%) 67%,
                hsl(34deg 100% 53%) 78%,
                hsl(45deg 100% 50%) 89%,
                hsl(55deg 100% 50%) 100%)`,
            backgroundAttachment:'fixed',
            backgroundSize:'contain'
        }}

            >
                &nbsp;
            </Box >
            
            <Avatar sx={{ bgcolor: 'secondary.main', width:'150px', height:'150px',
            border:'3px solid #000',marginBottom:'-1rem', boxShadow:'0px 0px 15px 5px rgba(0,0,0,0.8)',borderRadius:'20px'}} 
            src={owner_pic}>
            </Avatar>
            
            <Typography component="h1" variant="h5" 
            sx={{zIndex:1 , color:"#000", backgroundColor:'#FFF', fontFamily:'Gilroy',
                    padding:'0.25rem 0.75rem', borderRadius:'10px 10px 0 0', 
                    boxShadow:'0px -4px 3px 1px rgba(0,0,0,0.3)',marginTop:'0rem' }}
                     dangerouslySetInnerHTML={{ __html:tagLine_html}}>
               {/* <b>IT'S <i>ALL</i> GOOD!</b> */}
               {/* <b>{tagLine}</b> */}
            </Typography>  

            <Box sx={{ 
                display:'flex', flexDirection:'column', 
                gap:'0.5rem', borderRadius: '10px ',
                border:'4px ridge #000',
                minWidth:'300px',
                maxWidth:'600px',
                // width:'100%',
                // borderBottom:'none',
                backgroundColor:'#fff',
                justifyContent:'center',
                p:2, marginTop:'-1rem',
                boxShadow:'0px 0px 10px 5px rgba(0,0,0,0.7)',
                background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 15%, rgba(255,255,255,1) 95%, rgba(255,255,255,1) 100%)',
            }}>

            <Typography component="p" variant="" 
                sx={{zIndex:1 , color:"#000", backgroundColor:'#FFF', fontFamily:'Gilroy',
                    // padding:'0.25rem 0.25rem',
                    margin:'0'}}>
               <b>with</b>
            </Typography>
         

            <OperatingLogoCopy name={operating_name} split={1} font1={'Protest Riot'} font2={'Gilroy,sans-serif'} />
     
          <h3 style={{marginTop:'-1rem'}}>{description}!</h3> 
          <p>{owner_phone}</p> 
            {/* <Typography component="h1" variant="h4" sx={{fontFamily:'Glass Antiqua'}}>

            <b>{operating_name}</b>
            </Typography> */}
            {/* <Typography component="h2" variant="h5">
            Feel free to place an order
            </Typography> */}
            
             <Box sx={{position:'relative', padding: showAbout ? '0.75rem':'0rem 1rem', border: '1px dashed grey', 
             justifyContent:'center', borderRadius: '10px', width: !showAbout?'fit-content':'100%' ,margin: 'auto'}}>
                    <IconButton
                        aria-label="close"
                        onClick={handleAboutHide}
                         sx={{
                            position: showAbout?'absolute':'relative',
                            right: showAbout? 8:0,
                            top: showAbout? 8:0,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                            {showAbout?<CloseIcon />:<div style={{display:'flex',flexDirection:'column'}}>
                                🖐️
                                <MoreHorizIcon />
                            </div>
                            }
                        </IconButton>
                {showAbout &&  <Typography component="p" sx={{fontSize:'0.85rem', textAlign:'left',textIndent: '1rem'}} dangerouslySetInnerHTML={{ __html:infoHTML}}>
                     
                    
                {/* {infoHTML} */}
                {/* &nbsp; &nbsp;<b>Hi All! 🖐️ My name is Alix</b>, and I’m a scrub tech here at Duke Raleigh. <b>Please take a sample</b> of my <b>homemade Roasted Garlic Hummus </b>and<b> Apple Chicken Salad</b>!
                <br/>
                <br/>
                 &nbsp; &nbsp;I make these and many more delicious dishes in my home and sell them to close friends and family. I would like to extend my clientele and bring my love for food to all I can. 
                <br/>
                <br/>
                &nbsp; &nbsp;I'm currently working on a website that will showcase all I have to offer.
                <br/>
                <br/>
                If you are interested in these two items for purchase, <b>please fill out an order !</b>
                <br/> 
                <br/> 
                <b>Thanks so much!</b> */}
              
                </Typography>}
             </Box>
             
                <Button sx={{margin:'auto'}} variant='outlined' onClick={handleMenuOpen}><RestaurantMenuIcon />Menu </Button>
             <Stack direction="row" spacing={1} alignItems="center" justifyContent='center'>
                <Typography>Services</Typography>
                <Switch defaultChecked inputProps={{ 'aria-label': 'ant design' }} onChange={(e)=>{setOrderView(!orderView)}} checked={!orderView} />
                <Typography>Booking inquiries</Typography>
            </Stack>
            {!orderView && <TextField
                    placeholder="What do you have in mind?"
                    name='inquiry'
                    value={inquiryText}
                    onChange={handleInquiryChange}
                    multiline
                    rows={6}
                    // maxRows={10}
                    sx={{width:'100%'}}
                    />}
            {orderView && <Box sx={{display: 'flex', flexDirection:'column', width:'100%',
                    margin:'0.5rem auto', alignItems:'center',justifyContent:'center'}}>

                {/* { items && items.map((o,i)=>{ */}

                {/* { services && services?.map((o,i)=>{ */}

                    {/* return (  */}
                        <Accordion sx={{ margin:'auto',width:'100%',boxShadow:'0px 0px 10px 2px rgba(0, 0, 0, 0.3)',}} defaultExpanded>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            >

                            {/* {o?.type} |  ( 16oz. )  X  1 */}
                            Services
                            {/* <Rating name="half-rating" defaultValue={getAvg(o?.rating?.ratings) } precision={0.5} /> */}
                            <Rating name="half-rating" defaultValue={5} precision={0.5} />
                            {/* {tempOrder[i]?.size ? tempOrder[i]?.size:'___'}  X  { tempOrder[i]?.quantity? tempOrder[i]?.quantity:'___'} */}
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box
                                    component="img"
                                    sx={{
                                        height: 'auto',
                                        width: 270,
                                        // maxHeight: { xs: 233, md: 167 },
                                        maxWidth: { xs: 300, md: 250 },
                                        borderRadius: '15px 15px 0px 0px',
                                        margin:'auto',
                                        padding: '0.5rem'
                                    }}
                                    alt= {'services'}
                                    src= {cover_pic}
                                    />

                                <Box sx={{ p: 2, border: '1px dashed grey',
                                borderRadius:3, 
                                boxShadow:'inset 0px 0px 5px 3px rgba(0, 0, 0, 0.3)',
                                justifyContent:'center' }}>
                                <List >
                                {services?.map((s,i)=>{return(<ListItem key={i}>
                                    <ListItemIcon > <StarIcon /></ListItemIcon>
                                    {s}</ListItem>)})}  

                                </List>
                                {/* {o?.descr} */}
                                {/* <SignupOrderOption option={o} index={i} userObj={orderObj}/> */}
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    {/* )}) */}
                {/* } */}
                </Box>}
            {!orderView &&<Box component="form" //noValidate 
                // onSubmit={orderView? handleSubmit : handleInquirySubmit } 
                sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                    autoComplete="given-name"
                    name="firstName"
                    required
                    fullWidth
                    id="firstName"
                    label="First Name"
                    autoFocus
                    onChange={(e)=>setFirstName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                    onChange={(e)=>setLastName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                     onChange={(e)=>setEmail(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    name="phone"
                    label="Phone"
                    type="phone"
                    id="phone"
                    autoComplete="phone"
                     onChange={(e)=>setPhone(e.target.value)}
                    />
                </Grid>
                {/* <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    name="department"
                    label="Department"
                    type="text"
                    id="department"
                    autoComplete="department"
                     onChange={(e)=>setDepartment(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    name="notes"
                    label="Notes"
                    type="text"
                    id="notes"
                    autoComplete="notes"
                     onChange={(e)=>setNotes(e.target.value)}
                    />
                </Grid> */}
                
                
                <Grid item xs={12} >
                    <FormControlLabel sx={{margin:'auto'}}
                    control={<Checkbox value={isFollower} onChange={(e)=>{setIsFollower(!isFollower)}} checked={isFollower} color="primary"/>}
                    label="I want to receive information, marketing promotions and updates via email."
                    />
                </Grid>
                </Grid>
                <React.Fragment>
                    <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={orderView? handleSubmit : handleInquirySubmit } 
                    disabled={isSubmitting?true:false}
                    >
                    Submit{isSubmitting?'ting':''}
    
                    </Button>
                    {actionError}

                    {(open && !orderView && signupData?.inquiry  && signupData?.email)  && <InquirySendModal open={open} order={signupData} 
                    owner_email={owner_email}
                    owner={owner}
                    />}

                    {(open && orderView && signupData?.email ) && <ConfirmSignupModal open={open}  order={{...signupData,order:[...tempOrder]}} email={email}
                    owner_email={owner_email}
                    operating_name={operating_name}
                    userObj={{firstName, lastName, email, phone, department, inquiryText, isFollower, }}
                    owner={owner}
                    />}
                </React.Fragment>

                <Grid container justifyContent="flex-end">
                <Grid item>
                    {/* <Link href="#" variant="body2">
                    Already have an account? Sign in
                    </Link> */}
                </Grid>
                </Grid>
            </Box>}
            </Box>
            </Box>
            <Box sx={{margin:'1rem auto', marginBottom: '0'}}>

            <Copyright view='signupSheet'/>
            </Box>
        </Container>
        </ThemeProvider>
        </Container>
    </SignupProvider>
  );
}